<template>
  <div class="publicMain">
    <div class="mianbao">
      <!--  -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '#' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>养老服务机构</el-breadcrumb-item>
        <el-breadcrumb-item>居家养老</el-breadcrumb-item>
        <el-breadcrumb-item>服务工单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 模糊查询 -->
    <div class="childrenFileSelect">
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <div>
          <el-form-item label="工单流水号">
            <el-input v-model="form.homeName"></el-input>
          </el-form-item>
          <el-form-item label="服务项目">
            <el-input v-model="form.homeName"></el-input>
          </el-form-item>
          <el-form-item label="机构">
            <el-input v-model="form.homeName"></el-input>
          </el-form-item>
          <el-form-item label="服务人员">
            <el-input v-model="form.homeName"></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input v-model="form.homeName"></el-input>
          </el-form-item>
        </div>

        <div>
          <el-form-item label="客户电话">
            <el-input v-model="form.homeName"></el-input>
          </el-form-item>
          <el-form-item label="服务时间" required>
            <el-col :span="11">
              <el-form-item prop="date1">
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="form.date1"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="text-align: center">-</el-col>
            <el-col :span="11">
              <el-form-item prop="date2">
                <el-time-picker
                  placeholder="选择时间"
                  v-model="form.date2"
                  style="width: 100%"
                ></el-time-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onCheck">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="onReset">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!-- 新增按钮 -->
    <div class="add">
      <el-button type="primary" @click="addDate" size="medium">新增</el-button>
    </div>
    <!-- 表格 -->
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          type="index"
          width="50"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          v-for="(item, index) in tableColumn"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          align="center"
          :width="item.type == 'button' ? 300 : ''"
        >
          <template slot-scope="scope">
            <div v-if="item.type == 'button'" style="width: 300px">
              <el-button type="primary" size="mini" @click="check(scope.row)"
                >查看</el-button
              >
              <el-button
                type="success"
                size="mini"
                @click="compile(scope.row)"
                v-if="scope.row.state == 1 || scope.row.state == 4"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="remove(scope.row)"
                v-if="scope.row.state == 1 || scope.row.state == 4"
                >删除</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="audit(scope.row)"
                v-if="scope.row.state == 2"
                >审核</el-button
              >
              <el-button
                type="success"
                size="mini"
                @click="pass(scope.row)"
                v-if="scope.row.state == 4 || scope.row.state == 5"
                >通过</el-button
              >
              <el-button
                type="danger"
                size="mini"
                @click="unpass(scope.row)"
                v-if="scope.row.state == 3"
                >撤销通过</el-button
              >
            </div>
            <div v-if="item.type == 'state'">
              <div style="text-align: center">
                <el-tag v-if="scope.row[item.prop] == 1">待提交</el-tag>
                <el-tag v-if="scope.row[item.prop] == 2" type="info"
                  >待审核</el-tag
                >
                <el-tag v-if="scope.row[item.prop] == 3" type="success"
                  >通过</el-tag
                >
                <el-tag v-if="scope.row[item.prop] == 4" type="danger"
                  >不通过</el-tag
                >
                <el-tag v-if="scope.row[item.prop] == 5" type="warning"
                  >撤销通过</el-tag
                >
              </div>
            </div>
            <div
              v-else
              :style="{
                'text-align': item.align ? item.align : 'center',
              }"
            >
              {{ scope.row[item.prop] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 弹窗 -->
    <el-dialog :title="title" :visible.sync="visible" width="50%">
      <div class="slot">
        <serveWorkOrderDialog
          :buttonType="buttonType"
          :row="row"
          @save="save"
          @cancel="cancel"
          v-if="visible"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {
//   getAllChildrenList,
//   childrenHomeEdit,
//   childrenHomeDelete
// } from "./api";
import serveWorkOrderDialog from "./components/serveWorkOrderDialog.vue"
export default {
  components: {
    serveWorkOrderDialog,
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      //模糊查询数据
      form: {
        user: "",
        region: "",
      },
      title: "", //el-dialog标题
      visible: false,
      //table表格的column
      tableColumn: [
        {
          prop: "homeName",
          label: "工单流水号",
        },
        {
          prop: "contactNumber",
          label: "工单状态",
        },
        {
          prop: "contactNumber",
          label: "客户姓名",
        },
        {
          prop: "homeAddress",
          label: "联系方式",
        },
        {
          prop: "number",
          label: "服务项目",
        },
        {
          prop: "createName",
          label: "服务公司",
        },
        {
          prop: "createDate",
          label: "工单来源",
        },
        {
          prop: "createDate",
          label: "服务开始时间",
        },
        {
          prop: "createDate",
          label: "服务结束时间",
        },
        {
          type: "button",
          label: "操作",
        },
      ],
      //table表格的数据
      tableData: [],
      buttonType: "", //按钮的类型
      row: {}, //点击当前按钮的row数据
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10,
    }
  },
  methods: {
    //查询
    onCheck() {
      this.getAllChildrenListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        ...this.form,
      })
      this.$message({
        message: "查询成功",
        type: "success",
      })
    },
    //重置
    onReset() {
      this.form = {}
      this.getAllChildrenListAPI({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
      this.$message({
        message: "重置成功",
        type: "success",
      })
    },
    //每页请求数据
    handleSizeChange(val) {
      this.pageSize = val
      this.getAllChildrenListAPI()
      this.$message({
        message: `每页请求${val}条数据成功`,
        type: "success",
      })
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.pageNo = val
      this.getAllChildrenListAPI()
      this.$message({
        message: `请求第${val}页数据成功`,
        type: "success",
      })
    },
    //拿到儿童之家的列表
    getAllChildrenListAPI(e) {
      let params = Object.assign({}, e, {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
      getAllChildrenList(params).then((res) => {
        this.tableData = res.content.list
        this.total = res.content.count
      })
    },
    //新增
    addDate() {
      this.visible = true
      this.buttonType = "add"
      this.title = "新增"
    },
    //保存按钮
    save(e, type) {
      childrenHomeEdit(e).then((res) => {
        this.$message({
          message: type + "成功",
          type: "success",
        })
        this.visible = false
      })
      this.getAllChildrenListAPI()
    },
    //查看
    check(e) {
      this.buttonType = "check"
      this.row = e
      this.visible = true
      this.title = "查看"
    },
    //编辑
    compile(e) {
      this.buttonType = "compile"
      this.row = e
      this.visible = true
      this.title = "编辑"
    },
    //审核
    audit(e) {
      this.buttonType = "audit"
      this.row = e
      this.visible = true
      this.title = "审核"
    },
    //删除
    remove(e) {
      this.$confirm("确认永久删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          childrenHomeDelete({ id: e.id }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            })
            this.getAllChildrenListAPI()
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    //取消按钮
    cancel() {
      this.visible = false
    },
    //通过
    pass(row) {
      this.$confirm("确认通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          childrenHomeEdit({ id: row.id, state: 3 }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            })
            this.getAllChildrenListAPI()
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          })
        })
    },
    //不通过
    unpass(row) {
      this.$confirm("确认撤销通过吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          childrenHomeEdit({ id: row.id, state: 5 }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            })
            this.getAllChildrenListAPI()
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          })
        })
    },
  },
  created() {
    this.getAllChildrenListAPI({
      pageNo: 1,
      pageSize: 10,
    })
  },
}
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  margin-top: 20px;
}
.table {
  margin: 20px 0px;
}
.add {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  margin: auto;
}
</style>
